import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import useClasses from '../../helpers/useClasses';


const styles = theme => ({
  root: {
    height: '100%',
    background: '#fff'
  },
  content: {
    height: '100%'
  }
});

const Blank = props => {
  const classes = useClasses(styles);

  return (
    <div className={classes.root}>
      <main className={classes.content}><Outlet /></main>
    </div>
  );
};

Blank.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Blank;
